import styled from 'styled-components';
import { Button } from '@mui/material';

export const NotFoundPageWrapper = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(72vh, 640px);
  padding: 48px 24px 64px;
  box-sizing: border-box;
`;

export const NotFoundCard = styled.div`
  width: 100%;
  max-width: 480px;
  text-align: center;
  padding: 40px 32px 36px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(13, 78, 254, 0.12);
  box-shadow:
    0 24px 56px rgba(13, 78, 254, 0.1),
    0 8px 24px rgba(0, 0, 0, 0.04);
`;

export const NotFoundHeaderBand = styled.div`
  margin: -40px -32px 28px;
  padding: 28px 32px 24px;
  border-radius: 16px 16px 0 0;
  background: linear-gradient(
    135deg,
    rgba(1, 235, 178, 0.14) 0%,
    rgba(13, 78, 254, 0.1) 55%,
    rgba(13, 78, 254, 0.04) 100%
  );
  border-bottom: 1px solid rgba(13, 78, 254, 0.1);
`;

export const NotFoundCode = styled.p`
  margin: 0 0 8px;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0d4efe;
  font-family: 'Roboto', sans-serif;
`;

export const NotFoundTitle = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1a1a2e;
  font-family: 'Roboto', sans-serif;
  line-height: 1.25;
`;

export const NotFoundMessage = styled.p`
  margin: 0 0 28px;
  font-size: 1rem;
  line-height: 1.65;
  color: #5a6478;
  font-family: 'Roboto', sans-serif;
`;

export const NotFoundActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`;

export const NotFoundPrimaryButton = styled(Button)`
  && {
    text-transform: none;
    font-weight: 600;
    border-radius: 10px;
    padding: 10px 22px;
    color: #fff;
    background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%);
    box-shadow: 0 4px 14px rgba(13, 78, 254, 0.35);
  }

  &&:hover {
    background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%);
    opacity: 0.93;
    box-shadow: 0 6px 18px rgba(13, 78, 254, 0.42);
  }
`;

export const NotFoundSecondaryButton = styled(Button)`
  && {
    text-transform: none;
    font-weight: 600;
    border-radius: 10px;
    padding: 10px 20px;
    color: #1a1a2e;
    border-color: rgba(13, 78, 254, 0.28);
    background-color: #fff;
  }

  &&:hover {
    border-color: #0d4efe;
    background-color: rgba(13, 78, 254, 0.06);
  }
`;
